import { render, staticRenderFns } from "./create-diode-form.vue?vue&type=template&id=38a335f1&scoped=true&"
import script from "./create-diode-form.vue?vue&type=script&lang=js&"
export * from "./create-diode-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a335f1",
  null
  
)

export default component.exports